import { fetch } from "@deere/scs-fetch";
import { URL_SURVEY_API } from '../utils/constEnvVariables'

export const getTSPSurveyPartsBySupplier = async (suppliers, campaignId, accessToken, surveyCode) => {
  if(campaignId && Array.isArray(suppliers) && suppliers.length > 0 && accessToken){
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            suppliers: suppliers,
            campaignId: campaignId
        })
    }

    return fetch(`${URL_SURVEY_API}/surveys/${surveyCode.toLowerCase()}/parts/`, requestOptions)
  }
  return undefined
}

export const getTPSResponsesByAssignment = function (assignmentId, accessToken, surveyCode) {
  return fetch(`${URL_SURVEY_API}/surveys/${surveyCode.toLowerCase()}/responses/${assignmentId}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }).then(res => { return res })
      .catch(error => {
          console.log(error);
          //There is not answers in db yet
          return [];
      })
}

export const getTPSResponseById = function (responseId, accessToken, surveyCode) {
  return fetch(`${URL_SURVEY_API}/surveys/${surveyCode.toLowerCase()}/response/${responseId}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }).then(res => { return res })
      .catch(error => {
          console.log(error);
          //There is not answers in db yet
          return [];
      })
}

export const deleteTpsResponseByResponseId = function (responseId, accessToken, surveyCode) {
  const requestOptions = {
      method: 'DELETE',
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }

  return fetch(`${URL_SURVEY_API}/surveys/${surveyCode.toLowerCase()}/response/${responseId}`, requestOptions)
      .then(response => {
          return response
      })
      .catch(error => { throw error });
}

export const submitTpsResponse = function (request, accessToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/tps/response`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const submitTpsmexResponse = function (request, accessToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/tpsmex/response`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}
